import { Injectable } from '@angular/core';

import { TaskLog } from '../models';
import { AppState } from '../app-state';

import taskLogSchema from '../schema/task-log-schema';
import { RxDocument } from 'rxdb';
import { TestbedRxdbCouchCollectionService } from './testbed-rxdb/testbed-rxdb-couch-collection.service';
import { TestbedRxdbState } from './testbed-rxdb/testbed-rxdb-state';
import { AuthenticationService } from './authentication.service';

export type PathTestLogDoc = RxDocument<TaskLog,{}>

@Injectable({ providedIn: 'root' })
export class PathTestLogService extends TestbedRxdbCouchCollectionService<TaskLog,PathTestLogDoc>{

    constructor( appState : AppState, rxdbState: TestbedRxdbState, authService: AuthenticationService) { 
        super('path_test_log', taskLogSchema, appState, rxdbState, authService )
        this.syncConfig = {
            push: true,
            pull: true,
            intervalMs: this.appState.settings.get('rxdb.collections.path_test_log.intervalMs',0),
            retry: true
        }
    }


    create( taskLog : TaskLog) {
        console.log("create() " + JSON.stringify(taskLog));
        taskLog._id = this.generateId()
        return this.rxCollection.insert(this.rxCollection.newDocument(taskLog))
    }

}